import { lazy, Suspense } from "react";
import { Route, Switch, Redirect } from "wouter";
import { useAuthStore } from "@/stores/auth";
import { Layout } from "@/components/layout/Layout";
import { Login } from "@/routes/Login";
import { Dashboard } from "@/routes/Dashboard";
import { Services } from "@/routes/Services";
import { Investigations } from "@/routes/Investigations";
import { Chat } from "@/routes/Chat";
import { Loader2 } from "lucide-react";

const Reports = lazy(() => import("@/routes/Reports").then((m) => ({ default: m.Reports })));
const Settings = lazy(() => import("@/routes/Settings").then((m) => ({ default: m.Settings })));
const Audit = lazy(() => import("@/routes/Audit").then((m) => ({ default: m.Audit })));

function Loading() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}

export default function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated) {
    return (
      <Switch>
        <Route path="/login" component={Login} />
        <Route>
          <Redirect to="/login" />
        </Route>
      </Switch>
    );
  }

  return (
    <Layout>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route path="/" component={() => <Redirect to="/chat" />} />
          <Route path="/chat" component={Chat} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/services" component={Services} />
          <Route path="/investigations" component={Investigations} />
          <Route path="/reports" component={Reports} />
          <Route path="/audit" component={Audit} />
          <Route path="/settings" component={Settings} />
          <Route>
            <Redirect to="/dashboard" />
          </Route>
        </Switch>
      </Suspense>
    </Layout>
  );
}
